import React, { useEffect, useState } from 'react';
import { LanguageLoader } from '../../assets/languages';
import { GetPortalStatusAPI } from '../../services/index.js';
import { SetLoginSettings } from '../../redux/actions/loginSettings.js';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

// Utility to parse query string into object
function parseQueryString(qs) {
	const params = {};
	qs.replace(/^\?/, '').split('&').forEach(pair => {
		const [key, value] = pair.split('=');
		if (key) params[decodeURIComponent(key)] = decodeURIComponent(value || '');
	});
	return params;
}

const Utype = () =>
{
	const location = useLocation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const dispatch = useDispatch();

	// Extract utype from token if present
	let initialTenant = '';
	const token = searchParams.get('token');
	if (token) {
		try {
			const decoded = atob(token);
			const params = parseQueryString(decoded);
			if (params.utype) {
				initialTenant = params.utype;
			}
		} catch (e) {
		}
	}
	if (!initialTenant) {
		initialTenant = searchParams.get('utype') || '';
	}

	const language_config = localStorage.getItem('language') ? localStorage.getItem('language') : 'fa_IR';
	const language = LanguageLoader(language_config);
	const [tenant, SetTenant] = useState(initialTenant);

	// Auto-submit if tenant is set from token and not already in localStorage
	useEffect(() => {
		if (token && initialTenant && localStorage.getItem('utype') !== initialTenant) {
			GetPortalStatus(initialTenant);
		}
	// eslint-disable-next-line
	}, [token, initialTenant]);

	// Only redirect if we are on /utype and the query string contains username, password, and utype
	if (
		location.pathname === '/utype' &&
		(window.location.search.includes('username=') && window.location.search.includes('password=') && window.location.search.includes('utype='))
	) {
		navigate('/login' + window.location.search, { replace: true });
		return null;
	}

	const GetPortalStatus = async (utype) =>
	{
		try
		{
			if(utype && utype.length)
			{
				const host = window.location.host;
				if(host.includes('.') && host.split('.')[0] === 'mobile')
				{
					localStorage.setItem('utype', utype);
					window.location.replace('/');
				}
				else
				{
					const APIResponse = await GetPortalStatusAPI(utype);
					if(APIResponse.status)
					{
						localStorage.setItem('utype', utype);
						localStorage.setItem('registration', APIResponse.registration);
						localStorage.setItem('notifyby', APIResponse.NotifyBy);
						if(APIResponse.login_page)
						{
							dispatch(SetLoginSettings(APIResponse.login_page));
						}
						window.location.replace('/');
					}
				}
			}
		}
		catch (ex) {}
	}

	return(
		<div>
			<div className="text-secondaryFont text-2xl font-medium text-center mt-14 absolute inset-x-0 -top-36">
				{language["AUTHENTICATION"]["TENANT_NAME"]}
			</div>
			<input type='text' autoCapitalize='off' id='tenant' className='text-center mb-5' value={tenant} onKeyDown={(e) => {if(e.key === "Enter") GetPortalStatus(tenant);}} onChange={(e) => SetTenant(e.target.value)} placeholder={language["AUTHENTICATION"]["TENANT_NAME"]}/>
			<button type='button' onClick={() => { GetPortalStatus(tenant); }} className='btn-primary mb-1 mt-30 w-full bg-primary text-secondaryFont'>{language["AUTHENTICATION"]["NEXT_STEP"]}</button>
		</div>
	);
}

export default Utype;